// Component 3: RevenueTable.jsx


const formatDateToDDMMYYYY = (dateInput) => {
  if (!dateInput) return '';

  // Handle both string dates and Date objects
  const date = dateInput instanceof Date ? dateInput : new Date(dateInput);

  // Check if the date is valid
  if (isNaN(date.getTime())) return 'Invalid date';

  const day = String(date.getDate()).padStart(2, '0');
  const month = String(date.getMonth() + 1).padStart(2, '0');
  const year = date.getFullYear();

  return `${day}-${month}-${year}`;
};


export const RevenueTable = ({ data }) => (
  <div className="overflow-x-auto rounded-lg border">
    <table className="min-w-full text-sm">
      <thead className="bg-gray-100 text-left">
        <tr>
          <th className="px-6 py-3 text-left text-xs font-medium text-gray-500 uppercase tracking-wider">Booking ID</th>
          <th className="px-6 py-3 text-left text-xs font-medium text-gray-500 uppercase tracking-wider">Movie</th>
          <th className="px-6 py-3 text-left text-xs font-medium text-gray-500 uppercase tracking-wider">Theatre</th>
          <th className="px-6 py-3 text-left text-xs font-medium text-gray-500 uppercase tracking-wider">Show Date</th>
          <th className="px-6 py-3 text-left text-xs font-medium text-gray-500 uppercase tracking-wider">Show Time</th>
          <th className="px-6 py-3 text-left text-xs font-medium text-gray-500 uppercase tracking-wider">Transaction ID</th>
          <th className="px-6 py-3 text-left text-xs font-medium text-gray-500 uppercase tracking-wider">Amount</th>
          <th className="px-6 py-3 text-left text-xs font-medium text-gray-500 uppercase tracking-wider">Status</th>
          <th className="px-6 py-3 text-left text-xs font-medium text-gray-500 uppercase tracking-wider">theatreBaseAmount</th>
          <th className="px-6 py-3 text-left text-xs font-medium text-gray-500 uppercase tracking-wider">theatreGstAmount</th>
          <th className="px-6 py-3 text-left text-xs font-medium text-gray-500 uppercase tracking-wider">theatrePayable</th>

          <th className="px-6 py-3 text-left text-xs font-medium text-gray-500 uppercase tracking-wider">platformFee</th>
          <th className="px-6 py-3 text-left text-xs font-medium text-gray-500 uppercase tracking-wider">platformGst</th>
          <th className="px-6 py-3 text-left text-xs font-medium text-gray-500 uppercase tracking-wider">gatewayCharges</th>
          <th className="px-6 py-3 text-left text-xs font-medium text-gray-500 uppercase tracking-wider">platformEarnings</th>
          {/* <th className="px-6 py-3 text-left text-xs font-medium text-gray-500 uppercase tracking-wider">Actions</th> */}
        </tr>
      </thead>
      <tbody>
        {data.map((item, i) => (
          <tr key={item._id} className="hover:bg-gray-50">
            <td className="px-6 py-4 whitespace-nowrap text-sm font-medium text-gray-900">
              {item.bookingId}
            </td>
            <td className="px-6 py-4 whitespace-nowrap text-sm text-gray-500 max-w-xs truncate">{item.movieName}</td>
            <td className="px-6 py-4 whitespace-nowrap text-sm text-gray-500 max-w-xs truncate">{item.theatreName}</td>
            <td className="px-6 py-4 whitespace-nowrap text-sm text-gray-500">{formatDateToDDMMYYYY(item.showDate)}</td>
            <td className="px-6 py-4 whitespace-nowrap text-sm text-gray-500">{item.showTime}</td>
            <td className="px-6 py-4 whitespace-nowrap text-sm text-gray-500 font-mono">{item.transactionId}</td>
            <td className="px-6 py-4 whitespace-nowrap text-sm text-gray-500 font-medium">₹{item.totalAmount}</td>
            <td className="px-6 py-4 whitespace-nowrap">
              <span className={`px-2 inline-flex text-xs leading-5 font-semibold rounded-full 
                                        ${item.transactionStatus === 'Success' ? 'bg-green-100 text-green-800' : 'bg-red-100 text-red-800'}`}>
                {item.transactionStatus}
              </span>
            </td>
            {/* <td className="px-6 py-4 whitespace-nowrap text-sm text-gray-500">
                                                         <button className="text-blue-600 hover:text-blue-800">View</button>
                                                      </td> */}

            <td className="px-6 py-4 whitespace-nowrap text-sm text-gray-500 font-medium">₹{item.theatreBaseAmount}</td>
            <td className="px-6 py-4 whitespace-nowrap text-sm text-gray-500 font-medium">₹{item.theatreGstAmount}</td>
            <td className="px-6 py-4 whitespace-nowrap text-sm text-gray-500 font-medium">₹{item.theatrePayable}</td>

            <td className="px-6 py-4 whitespace-nowrap text-sm text-gray-500 font-medium">₹{item.platformFee}</td>
            <td className="px-6 py-4 whitespace-nowrap text-sm text-gray-500 font-medium">₹{item.platformGst}</td>
            <td className="px-6 py-4 whitespace-nowrap text-sm text-gray-500 font-medium">₹{item.gatewayCharges}</td>
            <td className="px-6 py-4 whitespace-nowrap text-sm text-gray-500 font-medium">₹{item?.platformEarnings}</td>
          </tr>
        ))}
      </tbody>
    </table>
  </div>
);
